/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature 层；
 * 2. 负责定义正式结果体对象的统一抽象基类；
 * 3. 该对象用于承载“结果 mesh + 特征原型”的稳定关联。
 *
 * 文件职责：
 * 1. 继承现有 FeatureResultMesh，保留拓扑线/点/面能力；
 * 2. 显式保存所属特征原型，替代零散 metadata 反查；
 * 3. 为后续每种特征的专属结果对象提供统一基类。
 */

import type * as THREE from 'three';
import type { FeaturePrototype } from '../../feature/prototype/FeaturePrototype';
import { FeatureResultMesh } from './FeatureResultMesh';

/**
 * 特征正式结果体抽象基类。
 */
export abstract class FeatureResultObject<TPrototype extends FeaturePrototype = FeaturePrototype> extends FeatureResultMesh {
    /** 所属特征原型。 */
    private readonly prototype: TPrototype;

    /**
     * @param input 输入参数。
     */
    protected constructor(input: {
        prototype: TPrototype;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super({
            meshData: input.meshData,
            geometry: input.geometry,
            material: input.material,
        });
        this.prototype = input.prototype;
    }

    /**
     * 获取所属特征原型。
     *
     * @returns 特征原型。
     */
    public getFeaturePrototype(): TPrototype {
        return this.prototype;
    }
}
